var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCagedPets = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 4.348V3a3 3 0 1 1 6 0v1.348C24.733 5.702 29 10.853 29 17h1a1 1 0 1 1 0 2h-1v11h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-29a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H3V19H2a1 1 0 1 1 0-2h1C3 10.853 7.267 5.702 13 4.348M5 17v9h4v-7H7v-2h2V8.514C6.557 10.532 5 13.584 5 17m6 9h4v-7h-2v-2h2V6.045a10.9 10.9 0 0 0-4 1.154zm6 0h4v-7h-2v-2h2V7.2a10.9 10.9 0 0 0-4-1.155zm6 0h4v-7h-2v-2h2c0-3.416-1.557-6.468-4-8.486zM5 30v-2h22v2zM17 3v1h-2V3a1 1 0 1 1 2 0",
  clipRule: "evenodd"
})));
export default SvgCagedPets;